/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-03-11 16:11:07
 *
 *******************************************************/
// @flow

import React from 'react';
export function GlobeIcon(props) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.87721 12.4164C10.4364 11.4884 10.99 10.2468 11.1484 8.79961H12.7276C12.4524 10.43 11.3572 11.7852 9.87721 12.4164ZM3.27161 8.79961H4.85161C5.01001 10.2468 5.56281 11.4884 6.12281 12.4164C4.64281 11.7852 3.54761 10.43 3.27161 8.79961ZM6.12281 3.58281C5.56281 4.51081 5.01001 5.75241 4.85161 7.19961H3.27161C3.54761 5.56921 4.64281 4.21401 6.12281 3.58281ZM6.46121 7.19961C6.67641 5.66681 7.45241 4.38361 8.00121 3.64521C8.55081 4.38121 9.32521 5.66041 9.53881 7.19961H6.46121ZM7.99801 12.354C7.44921 11.6188 6.67481 10.3388 6.46041 8.79961H9.53801C9.32281 10.3324 8.54681 11.6164 7.99801 12.354ZM12.7276 7.19961H11.1484C10.99 5.75241 10.4364 4.51081 9.87721 3.58281C11.3572 4.21401 12.4524 5.56921 12.7276 7.19961ZM7.99961 1.59961C4.47081 1.59961 1.59961 4.47081 1.59961 7.99961C1.59961 11.5284 4.47081 14.3996 7.99961 14.3996C11.5284 14.3996 14.3996 11.5284 14.3996 7.99961C14.3996 4.47081 11.5284 1.59961 7.99961 1.59961Z"
        fill="#8C9196"
      />
    </svg>
  );
}
